<section class="badge-editor-container">
  <!-- Back Navigation -->
  <div class="back-navigation">
    <button class="back-btn" (click)="goBackToPersonaSelection()">
      <svg class="back-icon" viewBox="0 0 24 24">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.42-1.41L7.83 13H20v-2z" fill="currentColor" />
      </svg>
      <span>Select Different Persona</span>
    </button>
  </div>

  <!-- Main Content (horizontal layout) -->
  <div class="main-content">
    <app-variable-elements-list 
    [selectedTemplate]="selectedTemplate" 
    [variableElements]="variableElements" 
    [parentVariableElements]="parentVariableElements">
  </app-variable-elements-list>
    <app-badge-area
      [badgeForm]="badgeForm"
      [selectedTemplate]="selectedTemplate"
      (onBadgeSelected)="selectTemplate($event)"
      (onCancel)="onCancelTemplateSelection()"
      class="badge-area-wrapper"
    ></app-badge-area>
  </div>
</section>
